module.exports = __webpack_public_path__ + "static/media/Incapacity.42494522.png";